import { PCXKeyValue } from './PCXKeyValue';

export class SeedMetaData {
    ItemId: string;
    IsMarkedToDelete: boolean;
    EntityName: string;
    Key: string;
    Value: string;
    TranslatedValue: string;
    Label: PCXKeyValue[];
    Active: boolean;

    public static Compare(
        a: { Label: { Key: string; Value: string }[] },
        b: { Label: { Key: string; Value: string }[] },
        languageKey: string
    ): number {
        // we sort by the language that is currently selected
        return a.Label?.find(x => x.Key === languageKey).Value.toLowerCase() >
            b.Label?.find(x => x.Key === languageKey).Value.toLowerCase()
            ? 1
            : -1;
    }
}
